import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CreditCard, FileText, Loader2, ShieldCheck } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { fmtEur, fmtDate, openGedDoc } from './gedUtils';

export const FtpeCbList = ({ search = '' }) => {
  const { getAuthHeader } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/paiements-cb/admin/ftpe-cb`, { headers: getAuthHeader() })
      .then((r) => setData(r.data)).catch(() => setData({ items: [], error: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!data) return <Loader2 className="h-5 w-5 animate-spin text-slate-400" />;
  const q = search.toLowerCase();
  const items = data.items.filter((i) => !q || `${i.raison_sociale} ${i.email} ${i.recu_numero || ''}`.toLowerCase().includes(q));
  return (
    <div className="rounded-2xl border border-emerald-200 bg-emerald-50/40 p-4 space-y-2" data-testid="ftpe-cb-list">
      <p className="flex items-center gap-2 font-semibold text-emerald-900">
        <CreditCard className="h-4 w-4" /> Adhésions FTPE payées par carte bancaire
        <span className="text-xs font-normal text-emerald-800" data-testid="ftpe-cb-synthese">{items.length} · {fmtEur(items.reduce((s, i) => s + Number(i.montant || 0), 0))}</span>
      </p>
      {items.length === 0 ? <p className="text-sm text-slate-500">Aucune adhésion FTPE payée par CB.</p> : items.map((i) => (
        <div key={i.id} className="flex flex-wrap items-center gap-2 rounded-lg border border-emerald-200 bg-white px-3 py-2 text-sm" data-testid={`ftpe-cb-row-${i.id}`}>
          <span className="font-medium text-slate-900">{i.raison_sociale || '—'}</span>
          <span className="text-xs text-slate-500">{i.email}</span>
          <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-600 text-white">CB</span>
          <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800 inline-flex items-center gap-1"><ShieldCheck className="h-3 w-3" /> Validée</span>
          <span className="text-[10px] text-slate-500">{i.origine}</span>
          <span className="ml-auto tabular-nums font-semibold">{fmtEur(i.montant)}</span>
          <span className="text-xs text-slate-500">{fmtDate(i.date)}</span>
          <button type="button" disabled={!i.recu_ged_id} onClick={() => openGedDoc(i.recu_ged_id, getAuthHeader())} data-testid={`ftpe-cb-recu-${i.id}`}
            className="inline-flex items-center gap-1 text-xs text-emerald-700 hover:underline disabled:opacity-40"><FileText className="h-3.5 w-3.5" /> {i.recu_numero || 'Reçu'}</button>
          {i.attestation_ged_id && (
            <button type="button" onClick={() => openGedDoc(i.attestation_ged_id, getAuthHeader())} data-testid={`ftpe-cb-attestation-${i.id}`}
              className="inline-flex items-center gap-1 text-xs text-sky-700 hover:underline"><FileText className="h-3.5 w-3.5" /> Attestation {i.attestation_numero || ''}</button>
          )}
        </div>
      ))}
    </div>
  );
};
